import React from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import BindingForm from "./BindingForm"; // Assuming there's a BindingForm component
import {
  createBinding,
  getBindings,
  updateBinding,
} from "app/services/api/bindings"; // Assuming these API functions exist

const EditBinding = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { bindingId } = useParams();
  const isNew = !bindingId;

  const [loading, setLoading] = React.useState(false);
  const [initialValues, setInitialValues] = React.useState(null);

  React.useEffect(() => {
    let isMounted = true;
    const load = async () => {
      if (!bindingId) return; // new binding
      try {
        setLoading(true);
        const bindings = await getBindings();
        const found = (Array.isArray(bindings) ? bindings : []).find(
          (b) => String(b._id) === String(bindingId)
        );
        if (isMounted) setInitialValues(found || null);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [bindingId]);

  const handleSave = async (binding) => {
    setLoading(true);
    try {
      await (isNew ? createBinding : updateBinding)(binding);
      enqueueSnackbar(
        t("notifications.savedSuccessfully", {
          defaultValue: "Saved successfully",
        }),
        { variant: "success" }
      );
    } catch (error) {
      enqueueSnackbar(
        t("notifications.savedFailed", {
          defaultValue: "Saved failed",
        }),
        { variant: "error" }
      );
    } finally {
      setLoading(false);
    }

    navigate(-1);
  };

  return (
    <Box>
      {loading ? (
        <CircularProgress />
      ) : (
        <BindingForm
          initialValues={initialValues}
          onSave={handleSave}
          isNew={isNew}
        />
      )}
    </Box>
  );
};

export default EditBinding;
